import { render, staticRenderFns } from "./ListaDePropostas.vue?vue&type=template&id=530485c9"
import script from "./ListaDePropostas.vue?vue&type=script&lang=js"
export * from "./ListaDePropostas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports